import React, {useEffect, useState} from "react";
import {STATUS_SUCCESS} from "../helpers/FileEntity";
import {useSelector} from "react-redux";

function useStateFile() {
    const files = useSelector(state => state.file.data);
    const [isValid, setIsValid] = useState(true);

    useEffect(() => {
        const filesSuccess = files.filter(file => file.status === STATUS_SUCCESS);
        setIsValid(filesSuccess.length === files.length);
    }, [files]);

    return {
        files: files,
        isValid: isValid,
    }
}

export default useStateFile